// extracted by mini-css-extract-plugin
export default {"ctn":"StartButton_ctn__4B-Wp","btn":"StartButton_btn__sMvvD"};